
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';


interface ISection {
  id: string;
  area: string;
  validator: string;
  validatorName: string;
  validatorPosition: string;
  validatorProfileImage: {
    imageData: string,
    mimeType: string
  };
  delegateResponsibleAllow: boolean;
  delegateResponsible: string;
  delegateResponsibleName: string;
  delegateResponsiblePosition: string;
  dualResponsibleAllow: boolean;
  dualResponsible: string;
  dualResponsibleName: string;
  dualResponsiblePosition: string;
  children?: ISection[];
  isOpen?: boolean;
  isFirstNode?: boolean;
}



@Component({
  selector: 'app-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate(300, style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class OrgChartComponent {
  @Input() data: ISection;
  @Output() editEvent: EventEmitter<ISection> = new EventEmitter();

  ngOnInit(): void {
    if (this.data) {
      this.data.isFirstNode = true; // Marcar el primer nodo
    }
  }

  displayChildren(event: Event, person: ISection) {
    event.preventDefault();
    event.stopPropagation();
    person.isOpen = !person.isOpen;
  }


  editSection(event: Event, person: ISection): void {
    event.stopPropagation();
    event.preventDefault();
    this.editEvent.emit(person);
  }
}

